// extracted by mini-css-extract-plugin
export var fluid = "rUKl";
export var root = "-AsY";